<template>
  <q-page>
    <div class="q-pa-md">
      <Breadcrumbs path-name="supplier" />
      <q-table
        title="供應商管理"
        :data="supplierList"
        :columns="columns"
        row-key="name"
        :pagination.sync="tableSet"
      >
        <template v-slot:top="props">
          <div class="col-3 q-table__title">{{ routerInfo.title }}</div>
          <router-link :to="'/supplier/create'">
            <q-btn
              v-if="loginUser.permission && loginUser.permission.Supplier > 2"
              color="green"
              icon="create"
              label="新增供應商"
              style="right: 11px; top:5px; position: absolute;"
            />
          </router-link>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="status" :props="props">{{ basicStatus[props.row.is_active] }}</q-td>
            <q-td key="specialStatus" :props="props">{{ supplierSpecial[props.row.special_status] }}</q-td>
            <q-td key="nickName" :props="props">{{ props.row.title }}</q-td>
            <q-td key="tel" :props="props">{{ props.row.tel }}</q-td>
            <q-td key="date" :props="props">
              {{ (props.row.LastPurchase && props.row.LastPurchase.length >0)? props.row.LastPurchase[0].created_at : ""}}
            </q-td>
            <q-td key="action" :props="props">
              <router-link :to="'/supplier/edit/'+props.row.id">
                <q-btn
                  v-if="loginUser.permission && loginUser.permission.Supplier > 2"
                  color="green"
                  icon="create"
                  label="修改"
                />
              </router-link>
              <q-btn
                v-if="false"
                color="blue"
                icon="description"
                label="詳細資訊"
                @click="handleShowDetailClick(props.row)"
              />
              <delete-btn v-if="loginUser.permission && loginUser.permission.Supplier === 4" :delete-action="'supplierDelete'" :id="props.row.id"></delete-btn>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <q-dialog v-model="showInfo">
        <q-card style="width: 700px; max-width: 80vw;">
          <div class="q-pa-xs">
            <div class="row">
              <div class="col">
                <div class="text-h6">{{ DetailInfo.title }} 詳細資料</div>
              </div>
            </div>
            <div class="row q-gutter-md q-pa-sm">
              <div class="col col-xs-11 col-sm-12 col-md-3 col-lg-3">電話： {{ DetailInfo.tel }}</div>
              <div class="col col-xs-11 col-sm-12 col-md-4 col-lg-6">聯絡電話： {{ DetailInfo.contact_tel }}</div>
              <div class="col col-xs-11 col-sm-12 col-md-4 col-lg-6">傳真： {{ DetailInfo.fax }}</div>
              <div class="col col-xs-11 col-sm-12 col-md-11 col-lg-11">信箱： {{ DetailInfo.email }}</div>
              <div class="col col-xs-11 col-sm-12 col-md-11 col-lg-11">地址： {{ DetailInfo.address }}</div>
              <div class="col col-xs-11 col-sm-12 col-md-11 col-lg-11">網站： {{ DetailInfo.web_site }}</div>
              <div class="col col-xs-11 col-sm-12 col-md-4 col-lg-6">廠商官方Line： {{ DetailInfo.company_line_id }}</div>
              <div class="col col-xs-11 col-sm-12 col-md-4 col-lg-6">聯絡人： {{ DetailInfo.contact_name }}</div>
              <div class="col col-xs-11 col-sm-12 col-md-3 col-lg-6">聯絡人Line： {{ DetailInfo.contact_line_id }}</div>
              <div class="col col-xs-11 col-sm-12 col-md-3 col-lg-6">聯絡人電話： {{ DetailInfo.contact_tel }}</div>
            </div>
            <q-separator/>

            <div class="row q-gutter-md q-pa-sm">
              <div class="col col-xs-12 col-sm-12 col-md-5 col-lg-5">
                評分
                <q-rating
                  v-if="DetailInfo.rate_detail"
                  v-model="DetailInfo.rate_detail.rate"
                  size="2em"
                  :max="5"
                  color="yellow"
                />
              </div>
              <div class="col col-xs-12 col-sm-12 col-md-5 col-lg-5">
                <q-btn
                  icon="save"
                  label="儲存評價"
                  color="green"
                  @click="supplierSaveRate(DetailInfo)"
                />
              </div>
              <div class="col-12">
                <q-input 
                  v-if="DetailInfo.rate_detail"
                  v-model="DetailInfo.rate_detail.note"
                  type="textarea"
                  label="評分備註"
                />
              </div>
            </div>
          </div>
          
          <q-card-actions align="right">
            <q-btn
              flat
              v-show="DetailInfo.special_status !== 0"
              :label="supplierSpecial[DetailInfo.special_status]"
              color="blue"
            />
            <q-btn
              flat
              v-show="DetailInfo.special_status === 0"
              label="申請特約"
              color="green"
              @click="handleSendSpecial(DetailInfo)"
            />
            <q-btn flat label="Close" color="primary" v-close-popup/>
          </q-card-actions>
        </q-card>
      </q-dialog>
    </div>
  </q-page>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import DeleteBtn from '@/components/DeleteBtn'

  export default {
    name: "SupplierIndex",
    components: { Breadcrumbs, DeleteBtn },
    data() {
      return {
        showInfo: false,
        DetailInfo: {},

        columns: [
          // { name: 'status', align: 'center', label: '是否啟用', field: 'is_active', sortable: true,},
          // { name: 'specialStatus', align: 'center', label: '特約狀態', field: 'is_active', sortable: true,},
          { name: 'nickName', label: '供應商名稱', field: 'title', sortable: true },
          { name: 'tel', align: 'center', label: '聯絡電話', field: 'account', sortable: true },
          { name: 'date', align: 'center', label: '最後採購日'},
          { name: 'action', label: '操作', align: 'center', field: 'id' }
        ],
        tableSet: {
          sortBy: 'desc',
          descending: false,
          page: 1,
          rowsPerPage: 20
        }
      }
    },
    computed: {
      ...mapGetters(['supplierList', 'supplierSpecial', 'basicStatus', 'routerInfo', 'loginUser'])
    },
    created() {
      this.$store.dispatch('supplierGetList');
    },
    methods: {
      handleShowDetailClick(Obj){
        this.DetailInfo = Obj;
        this.showInfo = true;
      },
      handleSendSpecial(supplier) {
        this.$q.dialog({
          dark: true,
          title: '確認！',
          message: `是否確定要對「${supplier.title}」申請特約？`,
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.$store.dispatch('supplierSendSpecial', supplier)
            .then(res => {
              if (res.Answer) {
                supplier.special_status = 1
              }
            })
        })
      },
      ...mapActions(["supplierSaveRate"])
    }
  }
</script>

<style scoped>

</style>
